<template>

    <v-app>
        <v-navigation-drawer 
            v-model="drawer"
            :clipped="$vuetify.breakpoint.lgAndUp"
            v-if="mainStore.isLoggedIn"
            app
        >
            <v-list dense>
                <template v-for="mode in mainStore.network_modes">
                    <v-list-item
                        :key="mode.id_network_mode"
                        :to="{ name: 'ActiveSource', query: { network_mode: mode.id_network_mode } }"
                        @click.native="setNetworkModeFromSidebar(mode)"
                        :class="{'active-nav': current_network_mode && current_network_mode.id_network_mode === mode.id_network_mode}"
                    >
                        <v-list-item-action>
                            <v-icon v-if="mode.network.form_type === 'solar'">mdi-white-balance-sunny</v-icon>
                            <v-icon v-else-if="mode.network.form_type === 'narrativa'">mdi-book-open-page-variant</v-icon>
                            <v-icon v-else>mdi-form-select</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ mode.network[`name_${$i18n.locale}`] }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <!-- ...otros items fijos si es necesario... -->
            </v-list>
        
        </v-navigation-drawer>

        <v-app-bar 
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            color="primary"
            app
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-if="mainStore.isLoggedIn"  style="color: white;"/>
            <!-- Logos después del icono del menú -->
            <div class="d-flex align-center ml-2">
                <img src="/images/logo_afinni.png" alt="Logo Afinni" style="height:48px; width:auto; margin-right:16px;" />
                <img src="/images/logo_colegio.png" alt="Logo Colegio" style="height:100px; width:auto; border-radius:8px;" />
            </div>
            <v-spacer></v-spacer>
            <v-toolbar-items v-if="mainStore.isLoggedIn">
                <LocaleSwitcher/>
                <v-btn text  class="white--text">{{ mainStore.logged_user.name }}</v-btn>
                <v-btn icon @click="mainStore.logout" style="color: white;">
                    <v-icon>mdi-logout</v-icon>
                </v-btn>
            </v-toolbar-items>
            <v-toolbar-items v-else>
                <LocaleSwitcher/>
            </v-toolbar-items>
        </v-app-bar>

        <header>
        <link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">
        <link href="https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css" rel="stylesheet">
        
        </header>
        <v-main>
                <!-- <vue-particles color="#7afff6"/> -->

                <flash-message style="height: 8px; padding-top: 40px;"/>
                <keep-alive >
                    <router-view></router-view>
                </keep-alive>
                <loader/>  
        </v-main>

        <v-footer/>
    </v-app>

</template>

<script >

 import { useMainStore } from '@/store/main'
 import { mapStores} from 'pinia'
 import LocaleSwitcher from './components/LocaleSwitcher.vue';
 import Loader from './components/partials/_loader';
 import flashMessage from './components/partials/flashMessage';


 export default{
    data() {
        return {
            drawer: true,
            menus: [
                { 
                    icon: "mdi-crowd",
                    text: `${this.$t('menus.active_source')}`, 
                    route: "ActiveSource", 
                    roles: ["Admin"],
                    visible:true
                },
                
                // {
                //     icon: "mdi-account-group",
                //     text: `${this.$t('menus.culture')}`, 
                //     route: "Culture",
                //     roles: ["Admin"],
                //     visible:true
                // }
            ]
        };
    },

    
    components: { 
        LocaleSwitcher,
        Loader,
        flashMessage,
       
    },
    
    created() {


        if (this.mainStore.isLoggedIn) {
            this.mainStore.initialize();
            this.mainStore.setLoggedUser();
        }

        this.$axios.interceptors.request.use((config) => {
            // Do something before request is sent
            this.mainStore.loader= true;
            return config;
        }, (error) => {
            // Do something with request error
            this.mainStore.loader = false;
            return Promise.reject(error);
        });

        // Add a response interceptor
        this.$axios.interceptors.response.use((response) => {
            // Do something with response data
            this.mainStore.loader = false;
            return response;
        }, (error) => {
            this.mainStore.loader=false;
            //console.log(error);
            // Do something with response error
            if (error.response.status == 401) {

               // console.log('Ocurre error 401!');
                this.mainStore.$reset();
                localStorage.removeItem('access_token');
                this.mainStore.logged_user=Object.assign({},{id:'',
                                                            name:'',
                                                            email:'',
                                                            role:''});
                this.mainStore.token='';
                if (['login.invalid_token','login.missing_token'].includes(error.response.data.message)){
                    this.mainStore.setFlashMessage({message:'login.invalid_or_expired_token',type:'error'});
                    
                    this.$router.push('/login');
                    
                }
                    
            }

            return Promise.reject(error);
        });
    },

    computed: {
        ...mapStores(useMainStore),
        current_network_mode() {
            // Detecta el modo activo según la selección actual
            return this.mainStore.network_modes.find(
              m => this.selected_network_mode_theme && m.id_network_mode === this.selected_network_mode_theme.id_network_mode
            ) || null;
          },
    },

    watch:{

      '$i18n.locale'(){

       this.translateMenus();


      },
      'mainStore.isLoggedIn'(val) {
        if (val) {
          this.mainStore.setFlashMessage({ message: '¡Bienvenido/a!', type: 'success' });
        }
      },
    },
    methods: {

      translateMenus(){

        this.menus[0].text=this.$t('menus.active_source');
        this.menus[1].text=this.$t('menus.culture');

      },
      testFlashMessage() {
        this.mainStore.setFlashMessage({ message: '¡Pop-up funcionando!', type: 'success' });
      },
      setNetworkModeFromSidebar(mode) {
        // Cambia el modo de red activo al hacer clic en la barra lateral
        this.$emit('update:selected_network_mode_theme', mode);
        // Si usas Pinia o Vuex para la selección, actualiza ahí también
        // this.mainStore.selected_network_mode = mode;
      },
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600&display=swap');

* {
  font-family: 'Quicksand', 'Roboto', Arial, sans-serif !important;
}

#particles-js { 
  /*position: absolute;
  background-size: cover;
  top: 0; 
  bottom: 0; 
  left: 0;
  right: 0; 
  overflow-y: hidden; 
  z-index: 0;*/
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0; 
}

.v-data-table {
    position: absolute;
}
</style>

